import mapValues from 'lodash/mapValues';
import isObject from 'lodash/isObject';
export default function daContentNormalizer(content) {
    if (!content.entityMap) {
        content.entityMap = {};
    }
    mapValues(content.entityMap, function (entity) {
        var _a, _b;
        if (entity && entity.type === 'wix-draft-plugin-giphy') {
            var fixed = {
                config: { size: 'small', alignment: 'center' },
                gif: { originalUrl: '' },
            };
            if (typeof ((_b = (_a = entity === null || entity === void 0 ? void 0 : entity.data) === null || _a === void 0 ? void 0 : _a.gif) === null || _b === void 0 ? void 0 : _b.originalUrl) !== 'string') {
                entity.data = fixed;
            }
        }
    });
    mapValues(content.blocks, function (block) {
        if (!Array.isArray(block === null || block === void 0 ? void 0 : block.entityRanges)) {
            block.entityRanges = [];
        }
        else {
            mapValues(block.entityRanges, function (entityRange) {
                if (!isObject(entityRange)) {
                    entityRange = {
                        offset: 0,
                        key: 0,
                        length: 0,
                    };
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.offset)) {
                    entityRange.offset = 0;
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.key)) {
                    entityRange.key = 0;
                }
                if (!(entityRange === null || entityRange === void 0 ? void 0 : entityRange.length)) {
                    entityRange.length = 0;
                }
            });
        }
        if (!Array.isArray(block === null || block === void 0 ? void 0 : block.inlineStyleRanges)) {
            block.inlineStyleRanges = [];
        }
        else {
            mapValues(block.inlineStyleRanges, function (inlineRange) {
                if (!isObject(inlineRange)) {
                    inlineRange = {
                        offset: 0,
                        style: 'BOLD',
                        length: 0,
                    };
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.length)) {
                    inlineRange.length = 0;
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.offset)) {
                    inlineRange.offset = 0;
                }
                if (!(inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.style)) {
                    inlineRange.style = 'BOLD';
                }
                if (inlineRange === null || inlineRange === void 0 ? void 0 : inlineRange.style.startsWith('TEXT_TOOLS_COLOR_')) {
                    var parts = inlineRange.style.split('_');
                    if (parts[3]) {
                        inlineRange.style = JSON.stringify({
                            FG: parts[3],
                        });
                    }
                }
            });
        }
        if (!(block === null || block === void 0 ? void 0 : block.depth)) {
            block.depth = 0;
        }
        if (!(block === null || block === void 0 ? void 0 : block.key)) {
            block.key = 'foo';
        }
        if (!(block === null || block === void 0 ? void 0 : block.text)) {
            block.text = '';
        }
        if (!(block === null || block === void 0 ? void 0 : block.type)) {
            block.type = 'unstyled';
        }
    });
    return content;
}
//# sourceMappingURL=daContentNormalizer.js.map